"use client";

import { useEffect } from "react";
import Header from "../../../components/headerV2";
import Hero from "@/components/herov2";
import Experiences from "@/components/experiences";
import Tickets from "@/components/ticketsV2";
import Games from "@/components/gamesV2";
import Sponsors from "@/components/sponsors";
import Footer from "@/components/footer";
import BottomMenu from "@/components/bottomMenu";
import RegisterHome from "@/components/register";
import Artistas from "@/components/artistas";

export default function Home() {
  useEffect(() => {
    const targets = document.querySelectorAll<HTMLElement>(
      ".reveal-up, .reveal-scale, .float-soft",
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // Large sections on mobile may never reach 20% visible at once.
        threshold: 0.05,
        rootMargin: "0px 0px -5% 0px",
      },
    );

    targets.forEach((target) => observer.observe(target));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="site-shell pb-[calc(env(safe-area-inset-bottom)+104px)]">
      <Header />
      <div style={{ height: 124 }} />
      <Hero />
      <Experiences />
      <RegisterHome />
      <Tickets />
      <Artistas />
      <Games />
      <Sponsors />
      <Footer />
      <BottomMenu />
    </div>
  );
}
